export default __webpack_public_path__ + "7f5ab4e810ca252d7f05921cfb33cb6c.jpg";